<mc-toast #toastRef appearance="success" position="bottom-right" duration="3000">
  <mc-notification appearance="success" heading="Saved" [body]="toastMessage" closable></mc-notification>
</mc-toast>

<div class="binning-table-wrapper">
  <div class="binning-table-scroll">
    <table class="binning-table">
      <thead>
        <tr>
          <th class="col-kpi">
            <span class="mds-label mds-neutral--default__on-background-color">KPI</span>
          </th>

          @if (hasMeasurement) {
            <th class="col-measurement">
              <span class="mds-label mds-neutral--default__on-background-color">Measurement</span>
            </th>
          }

          @if (showUnit) {
            <th class="col-unit">
              <span class="mds-label mds-neutral--default__on-background-color">Unit</span>
            </th>
          }

          @for (score of scores; track score) {
            <th class="col-score">
              <div class="score-header-cell">
                <span class="mds-label score-badge" [style.background]="scoreColors[score].bg" [style.color]="scoreColors[score].text">{{
                  score
                }}</span>
              </div>
            </th>
          }
        </tr>
      </thead>

      <tbody>
        @for (kpi of kpis; track kpi.id; let rowIdx = $index) {
          <tr [class.row-odd]="isOddRow(rowIdx)" [class.row-disabled]="isDisabled(kpi.id)">
            <td class="cell-kpi">
              <span class="mds-body mds-neutral--default__on-background-color">{{ kpi.label }}</span>
            </td>

            @if (hasMeasurement) {
              <td class="cell-measurement">
                <span class="mds-label mds-neutral--default__on-background-color">{{ kpi.measurement ?? '' }}</span>
              </td>
            }

            @if (showUnit) {
              <td class="cell-unit">
                <span class="mds-body mds-neutral--default__on-background-color">{{ units[kpi.id] === 'None' ? '' : units[kpi.id] }}</span>
              </td>
            }

            @for (score of scores; track score) {
              <td class="cell-score">
                <div class="score-inputs">
                  @if (isKpiLowerBetter(kpi.id)) {
                    <div class="input-wrap">
                      <mc-input
                        fit="small"
                        type="number"
                        hiddenlabel
                        [label]="kpi.label + ' score ' + score + ' max'"
                        placeholder="Max"
                        [suffix]="getSuffix(kpi.id)"
                        [disabled]="readonly || isDisabled(kpi.id) || getLockedMax(kpi.id, score) !== null"
                        [value]="getLockedMax(kpi.id, score) ?? bins[kpi.id + '_' + score + '_max']"
                        [attr.invalid]="isInputInvalid(kpi.id, score, 'max') || null"
                        (input)="onMaxChange(kpi.id, score, $event)"></mc-input>
                    </div>
                    <span class="mds-label range-sep mds-neutral--default__on-background-color">–</span>
                    <div class="input-wrap">
                      <mc-input
                        fit="small"
                        type="number"
                        hiddenlabel
                        [label]="kpi.label + ' score ' + score + ' min'"
                        placeholder="Min"
                        [suffix]="getSuffix(kpi.id)"
                        [disabled]="readonly || isDisabled(kpi.id)"
                        [value]="bins[kpi.id + '_' + score + '_min']"
                        [attr.invalid]="isInputInvalid(kpi.id, score, 'min') || null"
                        (input)="onMinChange(kpi.id, score, $event)"></mc-input>
                    </div>
                  } @else {
                    <div class="input-wrap">
                      <mc-input
                        fit="small"
                        type="number"
                        hiddenlabel
                        [label]="kpi.label + ' score ' + score + ' min'"
                        placeholder="Min"
                        [suffix]="getSuffix(kpi.id)"
                        [disabled]="readonly || isDisabled(kpi.id)"
                        [value]="bins[kpi.id + '_' + score + '_min']"
                        [attr.invalid]="isInputInvalid(kpi.id, score, 'min') || null"
                        (input)="onMinChange(kpi.id, score, $event)"></mc-input>
                    </div>
                    <span class="mds-label range-sep mds-neutral--default__on-background-color">–</span>
                    <div class="input-wrap">
                      <mc-input
                        fit="small"
                        type="number"
                        hiddenlabel
                        [label]="kpi.label + ' score ' + score + ' max'"
                        placeholder="Max"
                        [suffix]="getSuffix(kpi.id)"
                        [disabled]="readonly || isDisabled(kpi.id) || getLockedMax(kpi.id, score) !== null"
                        [value]="getLockedMax(kpi.id, score) ?? bins[kpi.id + '_' + score + '_max']"
                        [attr.invalid]="isInputInvalid(kpi.id, score, 'max') || null"
                        (input)="onMaxChange(kpi.id, score, $event)"></mc-input>
                    </div>
                  }
                </div>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (!hideSave) {
    <div class="save-row">
      <mc-button
        label="Save"
        appearance="primary"
        [loading]="isSaving"
        [disabled]="hasAnyValidationError"
        (click)="save()"
        (keydown.enter)="save()"></mc-button>
    </div>
  }
</div>
